import { Calculator, MessageCircle } from "lucide-react";
import { COMPANY } from "@/data/services";

export default function FloatingActions() {
  const msg = encodeURIComponent(`Hola, quiero información sobre una reforma con ${COMPANY.name}.`);
  return (
    <div
      data-testid="floating-actions"
      className="fixed bottom-4 left-3 right-3 z-40 md:hidden flex gap-2"
    >
      <a
        href="#calculadora"
        data-testid="floating-calc-btn"
        className="flex-1 inline-flex items-center justify-center gap-2 h-12 rounded-full bg-[#004B87] text-white text-sm font-display font-semibold shadow-xl shadow-[#004B87]/30 active:scale-95 transition-transform"
      >
        <Calculator className="w-4 h-4" />
        Calcular
      </a>
      <a
        href={`https://wa.me/${COMPANY.whatsappIntl}?text=${msg}`}
        target="_blank" rel="noreferrer"
        data-testid="floating-wa-btn"
        className="flex-1 inline-flex items-center justify-center gap-2 h-12 rounded-full bg-emerald-600 text-white text-sm font-display font-semibold shadow-xl shadow-emerald-600/30 active:scale-95 transition-transform"
      >
        <MessageCircle className="w-4 h-4" />
        WhatsApp
      </a>
    </div>
  );
}
